import React from "react";
import { useState } from "react";
import { Dialog } from "@headlessui/react";
import { FunnelFill, Search } from "react-bootstrap-icons";
import useAuth from "hooks/useAuth";
import useFeatureFilter from "hooks/useFeatureFilter";

export default function FilterCard({ filter, setFilter }) {
  const { isProspect } = useAuth();
  const { showSearchFilters } = useFeatureFilter();
  const [open, setOpen] = useState(false);

  const onClickFilter = (value, type) => {
    const key = Object.keys(value)[0];
    const val = value[key];
    const newFilter = { ...filter };
    if (type === "single") {
      if (newFilter[key] === val) {
        delete newFilter[key];
      } else {
        newFilter[key] = val;
      }
    } else {
      if (newFilter[key]?.length) {
        if (newFilter[key].includes(val)) {
          const index = newFilter[key].indexOf(val);
          newFilter[key].splice(index, 1);
        } else {
          newFilter[key].push(val);
        }
      } else {
        newFilter[key] = [val];
      }
    }
    setFilter(newFilter);
  };

  return (
    <>
      {!isProspect && showSearchFilters && (
        <div className="is-flex is-align-items-center mb-3">
          <span onClick={() => setOpen(true)} className="button is-light">
            <FunnelFill className="has-text-grey-light mr-1" /> Filter
          </span>

          <div className="control has-icons-left ml-4 w-30r">
            <input
              onChange={e =>
                setFilter({ type: "search", searchValue: e.target.value })
              }
              placeholder="Filter Question, Answer, Usage, WinRate"
              className="input"
            />
            <span className="icon is-left">
              <Search />
            </span>
          </div>
        </div>
      )}
      <Dialog
        as="div"
        open={open}
        className="is-fixed inset-0 z-40 is-flex is-align-items-center is-justify-content-center"
        onClose={() => setOpen(false)}
      >
        <Dialog.Overlay className="is-fixed inset-0 has-background-dark opacity-30" />
        <div className="p-6 my-8 overflow-hidden has-background-white z-30 rounded-md w-40r">
          <div className="columns">
            <div className="column is-flex is-align-items-center is-one-quarter has-text-weight-semibold">
              Usage
            </div>
            <div className="buttons column is-flex is-align-items-center gap-3">
              <div
                onClick={() => onClickFilter({ usage: 25 }, "single")}
                className={`w-25r h-75 ${
                  filter?.usage === 25 ? "button is-info" : "button is-light"
                }  is-flex is-align-items-center is-justify-content-center`}
              >
                {"> 25%"}
              </div>
              <div
                onClick={() => onClickFilter({ usage: 50 }, "single")}
                className={`w-25r h-75 ${
                  filter?.usage === 50 ? "button is-info" : "button is-light"
                } is-flex is-align-items-center is-justify-content-center`}
              >
                {"> 50%"}
              </div>
              <div
                onClick={() => onClickFilter({ usage: 75 }, "single")}
                className={`w-25r h-75 ${
                  filter?.usage === 75 ? "button is-info" : "button is-light"
                } is-flex is-align-items-center is-justify-content-center`}
              >
                {"> 75%"}
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
